import { Model } from 'pinia-orm';
import { Str, Uid, HasMany, Bool, Attr } from 'pinia-orm/decorators';
import { SectionStep } from './SectionStep';
import { CourseSection } from 'src/modules/Course/models/CourseSection';
import { UserSection } from './UserSection';
import type { ApiSectionSection } from 'src/types/contentTypes';
import type { StrapiAttr } from 'src/types/strapi';

/** Scalar field types are derived from the backend schema — see src/types/strapi.ts. */
type SectionAttr<K extends keyof ApiSectionSection['attributes']> = StrapiAttr<
  ApiSectionSection,
  K
>;

export class Section extends Model {
  static override entity = 'sections';

  @Uid() declare id: number;
  @Str(null) declare documentId: string | null;
  @Str('') declare section_name: SectionAttr<'section_name'>;
  @Str('') declare subtitle: SectionAttr<'subtitle'>;
  @Str('') declare description: SectionAttr<'description'>;
  @Bool(false) declare is_reset: SectionAttr<'is_reset'>;
  @Attr(null) declare tags: SectionAttr<'tags'> | null;

  @HasMany(() => CourseSection, 'section_id')
  declare course_sections: CourseSection[] | null;

  @HasMany(() => UserSection, 'section_id')
  declare user_sections: UserSection[] | null;

  @HasMany(() => SectionStep, 'section_id') declare section_step:
    | SectionStep[]
    | null;
}
